import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";

const Mobilebar = () => {
  const navigate = useNavigate();
  // console.log(window.location.pathname)
  const itemData = [
    {
      name: "ประวัติการซื้อ",
      link: "/historylottery",
      icon: <ReceiptRoundedIcon fontSize="medium" />,
      position: "text-right",
    },
    {
      name: "หน้าหลัก",
      link: "/dashboard",
      icon: <HomeRoundedIcon fontSize="medium" />,
      position: "text-center",
    },
    {
      name: "ตรวจสอบผล",
      link: "/resultlottery",
      icon: <ManageSearchRoundedIcon fontSize="medium"/>,

      position: "text-left",
    },
  ];

  return (
    <nav className={`bg-gradient-to-tr from-[#f8eede] border-t border-[#b3853e] to-[#f8eede] fixed z-10 bottom-0 text-[#b3853e] text-xs container mx-auto ${window.location.pathname == '/playlottery' && 'hidden'}`}>
      <ul className="grid grid-cols-3 text-center">
        {itemData.map((data, i) => (
          <li  key={i} className={`flex-col`} onClick={() => navigate(data.link)}>
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? `inline-block rounded-full border-4 border-[#b3853e] p-2 bg-gradient-to-t from-[#f8eede] to-[#f8eede] text-[#b3853e] sticky mt-[-25px]`
                  : "text-xs"
              }
              to={data.link}
            >
              {data.icon}
            </NavLink>
            <p className="text-xs font-bold">{data.name}</p>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Mobilebar;
